/** @jsx jsx */
/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, max-len */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { mock } from './styles';

const styles = {
  bar: css({
    margin: '8px 16px', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: '12px',
  }),
  toggleWrap: css({
    display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', whiteSpace: 'nowrap', userSelect: 'none',
  }),
  toggle: css({
    display: 'inline-flex', alignItems: 'center', width: '34px', height: '18px', borderRadius: '9999px', padding: '2px', boxSizing: 'border-box', transition: 'background .15s',
  }),
  knob: css({
    width: '14px', height: '14px', borderRadius: '9999px', background: '#fff', boxShadow: '0 1px 2px rgba(0,0,0,.25)',
  }),
  status: css({
    fontSize: '12px', whiteSpace: 'nowrap',
  }),
};

export type SimulationBarProps = {
  bulkMode: boolean;
  onToggleBulk: () => void;
  /** 保存を待っている編集がある・送っている最中 */
  saving: boolean;
  /** 最後に保存が終わった時刻。まだ無ければ null */
  lastSavedAt: Date | null;
  editable: boolean;
};

const hhmm = (d: Date): string => `${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')}`;

/**
 * 一括登録モードの切り替えと、保存の状態
 *
 * 9/24 に「一時保存 → 反映」をやめ、編集はその場で保存するようにした。
 * 「反映」「破棄」のボタンはなくし、右端に保存中／保存済みだけを出す。
 */
const SimulationBar: React.FC<SimulationBarProps> = ({
  bulkMode, onToggleBulk, saving, lastSavedAt, editable,
}) => {
  const label = bulkMode
    ? 'パレットで選んでセルをクリックすると、続けて割り当てられます。変更はその場で保存されます'
    : 'セルをクリックして個別に編集できます。変更はその場で保存されます';
  return (
    <div css={styles.bar} style={{ background: bulkMode ? mock.primaryM95 : '#fff', border: `1px solid ${bulkMode ? mock.primaryM80 : mock.gray10}` }}>
      <div css={styles.toggleWrap} onClick={editable ? onToggleBulk : undefined} title={editable ? '' : '編集権限がありません'}>
        <span style={{ fontSize: '12px', fontWeight: 700, color: bulkMode ? mock.primary : mock.textSub }}>一括登録モード</span>
        <span css={styles.toggle} style={{ background: bulkMode ? mock.primary : mock.gray20, justifyContent: bulkMode ? 'flex-end' : 'flex-start' }}>
          <span css={styles.knob} />
        </span>
        <span style={{ fontSize: '11px', fontWeight: 700, color: bulkMode ? mock.primary : mock.textSub }}>{bulkMode ? 'ON' : 'OFF'}</span>
      </div>
      <span style={{ fontSize: '12px', color: mock.textSub, flex: 1 }}>{label}</span>
      {saving && <span css={styles.status} style={{ color: mock.primary, fontWeight: 700 }} aria-live="polite">保存中…</span>}
      {!saving && lastSavedAt && <span css={styles.status} style={{ color: mock.textSub }} aria-live="polite">{`保存しました ${hhmm(lastSavedAt)}`}</span>}
    </div>
  );
};

export default SimulationBar;
